import angular from 'angular';
import invisionUiModule from 'invision-ui';
import ChargeDetailsPopout from './charge.details.popout';
export default angular.module('invision.customercare.billingpayments.charge.details.popout', [invisionUiModule]).directive('uiChargeDetailsPopout', ChargeDetailsPopout).name;